import { render } from "./BusySpinner.vue?vue&type=template&id=32de8de6&ts=true"
import script from "./BusySpinner.vue?vue&type=script&lang=ts"
export * from "./BusySpinner.vue?vue&type=script&lang=ts"

import "./BusySpinner.vue?vue&type=style&index=0&id=32de8de6&lang=css"

import exportComponent from "/home/vsts/work/1/s/SeismicApp/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__